export default __webpack_public_path__ + "static/media/accessories.445724f1.jpg";